import type { FC, PropsWithChildren } from 'react'

import {
  AgentImageMulti,
  AvatarImage,
  MultiAgentImageWrapper,
} from '@liveHelper/components/Idle/AvatarImages.styles'
import { useMessagePreviewContext } from '@liveHelper/components/MessagePreviewProvider'
import {
  AGENT_FALLBACK_THUMBNAIL,
  DEFAULT_AGENT_THUMBNAIL,
} from '@liveHelper/constants'
import { useChatChannelConfig } from '@liveHelper/context/ChatChannelConfigContext'

interface AvatarImageProps {
  onClick?: () => void
  isHiding: boolean
}

/**
 * Avatar images for the idle widget
 */
export const AvatarImages: FC<PropsWithChildren<AvatarImageProps>> = (
  props,
) => {
  const { lastUnreadMessage } = useMessagePreviewContext()
  const chatChannelConfig = useChatChannelConfig()

  const avatarImage = lastUnreadMessage
    ? { name: lastUnreadMessage.name, url: lastUnreadMessage.avatar }
    : chatChannelConfig?.widget_style?.agent_avatars?.length
      ? chatChannelConfig?.widget_style.agent_avatars?.[
          chatChannelConfig?.widget_style.agent_avatars?.length - 1
        ]
      : {
          name: '',
          url:
            chatChannelConfig?.widget_style?.thumbnail_url ||
            DEFAULT_AGENT_THUMBNAIL,
        }

  return (
    <MultiAgentImageWrapper onClick={props.onClick}>
      <AvatarImage
        isLarge={chatChannelConfig?.widget_style?.avatar_size === 'large'}
        isHiding={props.isHiding}
        className="multiAgentImage"
      >
        {avatarImage.url ? (
          <AgentImageMulti
            src={avatarImage.url}
            role="none"
            fallbackComponent={
              <AgentImageMulti src={AGENT_FALLBACK_THUMBNAIL} role="none" />
            }
          />
        ) : (
          <AgentImageMulti src={AGENT_FALLBACK_THUMBNAIL} role="none" />
        )}
      </AvatarImage>
      {props.children}
    </MultiAgentImageWrapper>
  )
}
